module.exports = __webpack_public_path__ + "img/logo.1f9fe7ce.png";